import { render } from "./ObjectSearchResult.vue?vue&type=template&id=24871d3e"
import script from "./ObjectSearchResult.vue?vue&type=script&lang=js"
export * from "./ObjectSearchResult.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__